import { render } from "./UserQuestion.vue?vue&type=template&id=dd08fc94&scoped=true"
import script from "./UserQuestion.vue?vue&type=script&lang=js"
export * from "./UserQuestion.vue?vue&type=script&lang=js"

import "./UserQuestion.vue?vue&type=style&index=0&id=dd08fc94&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd08fc94"],['__file',"src/Components/ChatWidget/AssistantAi/Aicomponents/UserQuestion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd08fc94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd08fc94', __exports__)) {
    api.reload('dd08fc94', __exports__)
  }
  
  module.hot.accept("./UserQuestion.vue?vue&type=template&id=dd08fc94&scoped=true", () => {
    api.rerender('dd08fc94', render)
  })

}


export default __exports__